import { render, staticRenderFns } from "./MsgLayout.vue?vue&type=template&id=935d8ed6&scoped=true"
import script from "./MsgLayout.vue?vue&type=script&lang=js"
export * from "./MsgLayout.vue?vue&type=script&lang=js"
import style0 from "./MsgLayout.vue?vue&type=style&index=0&id=935d8ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d8ed6",
  null
  
)

export default component.exports